<template>
    <div>
        <GmapMap :center="center" :zoom="zoom" style="width: 100%; height: 400px">
            <GmapStreetViewPanorama :position="streetViewPosition" :pov="streetViewPov"
                style="width: 100%; height: 200px" />
        </GmapMap>
    </div>
</template>
  
  
<script>
import { gmapApi } from "vue2-google-maps";

export default {
    name: "TestMap",
    data() {
        return {
            center: { lat: 13.7563, lng: 100.5018 }, // ตำแหน่งเริ่มต้นของแผนที่
            zoom: 11, // ระดับซูมเริ่มต้น
            streetViewPosition: { lat: 13.7563, lng: 100.5018 }, // ตำแหน่งของ Street View
            streetViewPov: { heading: 0, pitch: 0 }, // มุมมองของ Street View
        };
    },
    methods: {
        loadStreetView() {
            gmapApi().then((maps) => {
                const panorama = new maps.StreetViewPanorama(
                    this.$refs.streetView.$el, // อ้างอิง DOM element ของ Street View
                    {
                        position: this.streetViewPosition,
                        pov: this.streetViewPov,
                    }
                );
                this.$refs.mapObject.map.setStreetView(panorama);
            });
        },
    },
    created() {
        this.loadStreetView();
    },
}
</script>
  
<style scoped></style>